require("./bootstrap");
require("./helpers");
require("./idleDetect");

import HoneybadgerVue from '@honeybadger-io/vue'
import {createApp, h} from "vue";
import {createInertiaApp, Head, Link} from "@inertiajs/inertia-vue3";
import {InertiaProgress} from "@inertiajs/progress";
import Datepicker from "@vuepic/vue-datepicker";
import Vue3EasyDataTable from "vue3-easy-data-table";
import dayjs from "dayjs";
import Vue3Tour from "vue3-tour";
import TextClamp from "vue3-text-clamp";
import InlineSvg from "vue-inline-svg";
import VueModal from "@kouts/vue-modal";
import Vue3TouchEvents from "vue3-touch-events";
import FrontendHeaderH1 from "@/Components/FrontendHeaderH1";
import FrontendHeaderH2 from "@/Components/FrontendHeaderH2";
import FrontendHeaderH3 from "@/Components/FrontendHeaderH3";
import Button from "@/Components/Button";
import Dropdown from "@/Components/Dropdown";

const honeyBadgerConfig = {
    apiKey: 'hbp_7mANPLLRtbjAXBiQKN7Q8gZds2Ggl00la2nj', environment: process.env.NODE_ENV, revision: '1'
}

dayjs.extend(require("dayjs/plugin/relativeTime"));
dayjs.extend(require("dayjs/plugin/utc"));
dayjs.extend(require("dayjs/plugin/timezone"));
dayjs.extend(require("dayjs/plugin/advancedFormat"));
dayjs.extend(require("dayjs/plugin/duration"));

let app = createInertiaApp({
    title: (title) => `${title} - EMTprep`,
    resolve: (name) => require(`./Pages/${name}.vue`),
    setup({el, app, props, plugin}) {
        let inertiaApp = createApp({render: () => h(app, props)});

        inertiaApp.config.globalProperties.dayjs = dayjs;

        inertiaApp
            .use(plugin)
            .use(HoneybadgerVue, honeyBadgerConfig)
            .use(Vue3Tour)
            .use(TextClamp)
            .use(Vue3TouchEvents)

            .mixin({methods: {route}})

            .component("Head", Head)
            .component("Link", Link)
            .component("Datepicker", Datepicker)
            .component("Modal", VueModal)
            // common page components
            .component("FrontendHeaderH1", FrontendHeaderH1)
            .component("FrontendHeaderH2", FrontendHeaderH2)
            .component("FrontendHeaderH3", FrontendHeaderH3)
            .component("Button", Button)
            .component("Dropdown", Dropdown)

            // third party components
            // .component("Tour", VueTour)
            .component("inline-svg", InlineSvg)
            .component("EasyDataTable", Vue3EasyDataTable)
            // .component("draggable", draggable)
            .mount(el);

        return inertiaApp;
    },
});

InertiaProgress.init({
    delay: 0, color: "#DD0000", includeCSS: true, showSpinner: true,
});
